// extracted by mini-css-extract-plugin
export default {"about_image":"about_about_image__9Z24p"};